<template>
  <v-list-item
    class="payment-widget-form"
    :class="(selected.UUID === 0 ? 'new' : 'edit')"
  >
    <v-list-item-icon>
      <v-icon
        v-text="(selected.UUID === 0 ? 'mdi-plus-thick' : 'mdi-playlist-edit')"
        :color="(selected.UUID === 0 ? 'green' : 'amber')"
      />
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        <v-form
          ref="paymentForm"
          v-model="valid"
          lazy-validation
        >
          <v-container class="form-container">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click.stop="$emit('closed')"
                  icon
                  medium
                  class="close-btn"
                  color="gray darken-2"
                >
                  <v-icon medium>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.new.payment.form.close }}</span>
            </v-tooltip>
            <!-- COBRANÇAS -->
            <template v-if="cat === 'income'">
              <v-row class="form-row">
                <v-col cols="12">
                  <v-text-field
                    v-model="selected.title"
                    :label="lang.orders.new.payment.form.title"
                    :rules="lang.orders.new.payment.form.rules.title"
                    filled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="form-row">
                <v-col cols="12">
                  <v-currency-field
                    v-model="selected.value"
                    :label="lang.orders.new.payment.form.value"
                    :rules="lang.orders.new.payment.form.rules.value"
                    filled
                  ></v-currency-field>
                </v-col>
              </v-row>
            </template>
            <!-- PAGAMENTOS -->
            <template v-else>
              <v-row class="form-row">
                <v-col cols="12">
                  <v-select
                    :value="selected.type"
                    :items="get_global.defaults.options.orders.payment.type"
                    :label="lang.orders.new.payment.form.type"
                    @change="typeChange"
                    filled
                    dense
                  ></v-select>
                </v-col>
              </v-row>
              <template v-if="selected.type > 1">
                <v-row class="form-row">
                  <v-col cols="12">
                    <v-currency-field
                      v-model="selected.value"
                      :label="lang.orders.new.payment.form.value"
                      :rules="lang.orders.new.payment.form.dyn_rules(selected.type, (debt + parseFloat(selected.value))).value"
                      filled
                    ></v-currency-field>
                  </v-col>
                </v-row>
                <v-row v-if="selected.type === 4" class="form-row">
                  <v-col cols="12">
                    <v-text-field
                      v-model="selected.parcels"
                      :label="lang.orders.new.payment.form.parcels"
                      :rules="lang.orders.new.payment.form.rules.parcels"
                      suffix="x"
                      type="number"
                      filled
                    />
                  </v-col>
                </v-row>
                <v-row v-if="selected.type < 5 && selected.type > 2" class="form-row">
                  <v-col cols="12">
                    <v-text-field
                      v-model="selected.tax"
                      :label="lang.orders.new.payment.form.card_tax"
                      :rules="lang.orders.new.payment.form.rules.tax_percent"
                      suffix="%"
                      filled
                    />
                  </v-col>
                </v-row>
              </template>
              <template v-else-if="selected.type === 1">
                <v-row class="form-row">
                  <v-col cols="12">
                    <v-text-field
                      v-model="selected.percent"
                      :counter="50"
                      :rules="lang.orders.new.payment.form.rules.percent"
                      :label="lang.orders.new.payment.form.percent"
                      suffix="%"
                      filled
                    />
                  </v-col>
                </v-row>
              </template>
            </template>
            <v-row class="actions-row">
              <v-col cols="12" class="pa-0">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click.stop="save_()"
                      icon medium
                    >
                      <v-icon medium color="green">mdi-content-save</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.new.payment.form.save }}</span>
                </v-tooltip>
                <v-tooltip left v-if="selected.UUID === 0">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      medium
                      @click.stop="clear_()"
                      color="gray darken-2"
                    >
                      <v-icon medium color="blue">mdi-broom</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.new.payment.form.clear }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    value: {
      type: Object,
      required: true
    },
    cat: {
      type: String,
      required: true
    },
    debt: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selected: { ...this.value },
      valid: false
    }
  },
  methods: {
    typeChange (type) {
      if (type > 2) {
        let debt = (this.value.UUID !== 0 ? parseFloat(this.debt + this.value.value) : parseFloat(this.debt))
        this.selected.value = debt
        this.selected.parcels = 1
        if (type === 3) {
          this.selected.tax = parseFloat(this.get_options.debit_tax)
        } else if (type === 4) {
          this.selected.tax = parseFloat(this.get_options.credit_tax)
        }
      } else {
        this.selected.value = 0
      }
      this.selected.type = type
    },
    save_ () {
      if (this.$refs.paymentForm.validate()) {
        let selected = { ...this.selected },
            options = this.get_global.defaults.options.orders.payment.type || [],
            option = options.find(opt => opt.value === selected.type) || false
        if (this.cat === 'paid') {
          switch (true) {
            case selected.type <= 2:
              selected.title = `${this.lang.orders.new.payment.paid.types.discount.title}${(selected.type === 1 ? ' (' + selected.percent + '%)' : '')}`
              break
            case selected.type > 2:
              selected.title = `${this.lang.orders.new.payment.paid.types.payment.title} ${(option ? '(' + option.text + ')' : '')}`
              break
          }
        }
        return this.$emit('saved', { ...selected })
      }
      return false
    },
    clear_ () {
      this.$refs.paymentForm.reset()
    }
  },
  mounted () {
    this.$refs.paymentForm.resetValidation()
  }
}
</script>

<style>

</style>